import { MailboxesStoreStateType } from '../../Types/MailboxesStoreTypes';
import { InlineUpdateType, MailboxInfoType } from '../../Types/MailboxProviderTypes';

export const defaultMailboxInfoData: MailboxInfoType = {
	folderId: 1,
	folderName: 'Inbox',
	folderSlug: 'inbox',
	mailTagIds: undefined,
	incomingRecipientNames: undefined,
	customFolderId: undefined,
};

export const defaultMailNote: InlineUpdateType = {
	data: null,
	success: false,
	updating: false,
	error: false,
};

export const defaultMailboxesStoreData: MailboxesStoreStateType = {
	searchActive: window.location.pathname.indexOf('/mail/search') > -1,
	searchReset: false,
	lastNonSearchLocation: '',
	parentFolderId: -1,
	itemMoving: false,
	showFilterModal: false,
	createCustomFolderOpen: false,
	deleteCustomFolderOpen: false,
	activeCustomFolderData: null,
	confirmActionData: { open: false, actionId: -1, mailIds: [] },
	forwardItemsData: { open: false, mailIds: [], mailItems: [] },
	mailFolderModificationActive: false,
	mailNote: defaultMailNote,
	mailBoxInfo: defaultMailboxInfoData,
	mailItemRequiresTopUp: false,
	mailItemOnHold: false,
	preItemUpdate: undefined,
};
